import React from "react";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {StyledRadio} from "../../../../../utils/designComponents/StyledRadio";
import {Typography} from "@material-ui/core";
import RadioGroup from "@material-ui/core/RadioGroup";

export default function InstrumentRadios({top, dispatchTop, setViewOptionManagementEnabled}) {
    return (
        <Grid container>
            <RadioGroup
                row
                aria-label="instrument"
                name="instrument"
                value={top.instrument}
                onChange={(ev) => {
                    dispatchTop({ instrument: ev.target.value });
                     setViewOptionManagementEnabled(ev.target.value === "option");
                     /*if (ev.target.value === "stock") {
                         if (symbolsUsed !== 1) {
                             setSymbolsUsed(1);
                         }
                     }
                     let isOption = ev.target.value === "option";
                     let isQty = top.quantityBasis === "QUANTITY";
                     let qtyBasisValue = 0;
                     if (props.defaultQtyBasis !== undefined) {
                         if (isOption) {
                             if (isQty) {
                                 qtyBasisValue = props.defaultQtyBasis["qtyOption"];
                             } else {
                                 qtyBasisValue = props.defaultQtyBasis["dollarOption"];
                             }
                         } else {
                             if (isQty) {
                                 qtyBasisValue = props.defaultQtyBasis["qtyStock"];
                             } else {
                                 qtyBasisValue = props.defaultQtyBasis["dollarStock"];
                             }
                         }
                         props.dispatchMarketOrder({
                             quantityBasisValue: qtyBasisValue,
                         });
                         props.dispatchLimitOrder({
                             quantityBasisValue: qtyBasisValue,
                         });
                         props.dispatchCandleBreak({
                             quantityBasisValue: qtyBasisValue,
                         });
                     }*/
                }}
            >
                <Grid item xs={6}>
                    <FormControlLabel
                        value="stock"
                        control={<StyledRadio/>}
                        label={
                            <Typography style={{fontSize: 10}}>stock</Typography>
                        }
                        labelPlacement={"bottom"}
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormControlLabel
                        value="option"
                        control={<StyledRadio/>}
                        label={
                            <Typography style={{fontSize: 10}}>option</Typography>
                        }
                        labelPlacement={"bottom"}
                    />
                </Grid>
            </RadioGroup>
        </Grid>
    )
}